import React, {
  useEffect,
  useState,
  useContext,
} from 'react';

import './FullLeaderboard.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { PageNavContext } from '../../../FunctionalPageLogin';

import AvatarPreview from '../profile/avatar/AvatarPreview';
import { defaultAvatar } from '../profile/avatar/avatarConfig';

const apiUrl = process.env.REACT_APP_API_URL;

export default function FullLeaderboard() {
  const pageNav = useContext(PageNavContext);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadLeaderboard = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/leaderboard?type=weekly`,
          {
            credentials: 'include',
          }
        );

        if (!response.ok) {
          throw new Error(
            'Nu am putut incarca clasamentul.'
          );
        }

        const data = await response.json();

        if (!isMounted) {
          return;
        }

        setUsers(
          Array.isArray(data)
            ? data
            : []
        );

        setError('');
      } catch (err) {
        if (!isMounted) {
          return;
        }

        console.error(
          'Eroare incarcare clasament complet:',
          err
        );

        setError(
          'Clasamentul nu poate fi afisat momentan.'
        );
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadLeaderboard();

    return () => {
      isMounted = false;
    };
  }, []);

  const visibleUsers = users.filter(
    (user) =>
      (Number(user?.points) || 0) > 0
  );

  return (
    <div className="full-leaderboard-page">

      {/* HEADER */}

      <div className="full-leaderboard-header">

        <button
          type="button"
          className="full-leaderboard-back"
          onClick={() => pageNav('Clasament')}
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
          />
        </button>

        <div>
          <h1>
            Clasamentul complet
          </h1>
        </div>

      </div>

      {/* LISTA */}

      <div className="full-leaderboard-list">

        {/* LOADING */}

        {loading && (
          <div className="full-leaderboard-message">
            Se incarca clasamentul...
          </div>
        )}

        {/* ERROR */}

        {!loading && error && (
          <div className="full-leaderboard-message">
            {error}
          </div>
        )}

        {/* USERS */}

        {!loading &&
          !error &&
          visibleUsers.map(
            (user, index) => {

              const rank =
                Number(user.position) ||
                index + 1;

              const userAvatar = {
                ...defaultAvatar,
                ...(user.avatar_config || {}),
              };

              return (
                <div
                  key={
                    user.user_id ||
                    `${user.display_name}-${index}`
                  }
                  className={[
                    'full-leaderboard-row',
                    rank === 1
                      ? 'full-leaderboard-row-first'
                      : '',
                    rank === 2
                      ? 'full-leaderboard-row-second'
                      : '',
                    rank === 3
                      ? 'full-leaderboard-row-third'
                      : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                >

                  {/* POZITIE */}

                  <div className="full-leaderboard-rank">
                    #{rank}
                  </div>

                  {/* AVATAR */}

                  <div className="full-leaderboard-avatar">
                    <AvatarPreview
                      avatar={userAvatar}
                      className="avatar-preview-full-leaderboard"
                    />
                  </div>

                  {/* NUME */}

                  <div className="full-leaderboard-name">
                    {user.display_name ||
                      'Utilizator'}
                  </div>

                  {/* XP */}

                  <div className="full-leaderboard-xp">
                    {Number(user.points) || 0} XP
                  </div>

                </div>
              );
            }
          )}

      </div>

    </div>
  );
}